import React from 'react';

const About = () => {
  return (
    <div name='about' className='w-full h-screen bg-[#0a192f] text-gray-300'>
      <div className='flex flex-col justify-center items-center w-full h-full'>
        <div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
          <div className='sm:text-right pb-8 pl-4'>
            <p className='text-4xl font-bold inline border-b-4 border-pink-600'>
              About
            </p>
          </div>
          <div></div>
          </div>
          <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
            <div className='sm:text-right text-4xl font-bold'>
              <p>Hi. I'm Shahid, nice to meet you.</p>
            </div>
            <div>
              <p>I am self taught passionate dev, and a SENIOR GRADUATE @LearnWeb3Dao.
               Who loves to build excellent software that help
              the lives of those around me. I am experienced in creating frontend
              for clients ranging from individuals and small-businesses all the
              way to large enterprise corporations. hope we would do something epic in the world of 
              WEB3 and TECH.
              Follow me on my socials to know more about me. 
              ALWAYS AVAILABLE !!!</p>  
            </div>
          </div>
      </div>
    </div>
  );
};

export default About;